import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { SmallLoader } from 'components/Loader';
import IntersectionObserver from 'components/common/IntersectionObserver';
import { combineSideEffects } from 'helpers';

import css from 'styles/components/common/image.scss';

const Image = ({ onLoad, placeholder, className, forceLoad, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const showPlaceholder = placeholder && !loaded && !forceLoad;
  return <>
    { showPlaceholder && placeholder}
    <img alt="" className={cn(className, css.image, { [css.loaded] : loaded })} onLoad={combineSideEffects(onLoad, () => setLoaded(true))} {...rest}/>
  </>;
};

Image.propTypes = {
  src: PropTypes.string.isRequired
};

Image.defaultProps = {
  placeholder: <div className={css.placeholder}><SmallLoader/></div>
};

export const LazyImage = ({ placeholder, forceLoad, ...rest }) => (
  <IntersectionObserver placeholder={placeholder} forceLoad={forceLoad}>
    <Image placeholder={placeholder} forceLoad={forceLoad} {...rest}/>
  </IntersectionObserver>
);

export default Image;
